var exports = {
  "i": "x28a7bf27--2aa3a9--wrapper",
};

module.exports = exports;
